import React, {useContext, useEffect, useState} from "react";
import { NavLink,Link } from "react-router-dom";
import {Button} from 'react-bootstrap';
import {Offcanvas} from 'react-bootstrap';
import { globalContext } from "../../App";

// const NAV = [
//   { to: "/", label: "Home", end: true },
// ];


const mainLinks=[{text:'TOne Home',link:'https://www.teluguone.com'},
                     {text:'News',link:'https://www.teluguone.com/news'},
                     {text:'Movie News',link:'https://www.teluguone.com/tmdb'},
                     {text:'Movies',link:'https://www.teluguone.com/movies'},
                     {text:'Photos',link:'https://www.teluguone.com/photos'},
                     {text:'Grandalayam',link:'https://www.teluguone.com/grandalayam'},
                      {text:'Shortfilms',link:'https://www.teluguone.com/shortfilms'},
                      {text:'Videos',link:'https://www.teluguone.com/videos'},                 
                       {text:'TORi(Radio)',link:'https://www.teluguoneradio.com'},
                       {text:'Recipes',link:'https://www.teluguone.com/recipes'},                                                           
]
const mobileMenuLinks=[{ text: 'TOne Home', link: 'https://www.teluguone.com' },{text:"News",link:"https://www.teluguone.com/news"},{text:"Movie News",link:"https://www.teluguone.com/tmdb"},
  {text:"Movies",link:"https://www.teluguone.com/movies"},{text:"Photos",link:"https://www.teluguone.com/photos"},
  {text:"Grandalayam",link:"https://www.teluguone.com/grandalayam"},{text:"Shortfilms",link:"https://www.teluguone.com/shortfilms"},
  {text:"Bakthi",link:"https://www.teluguone.com/devotional"},{text:"Videos",link:"https://www.teluguone.com/videos"},{text:"Recipes",link:"https://www.teluguone.com/recipes"},
  {text:"Comedy",link:"https://www.teluguone.com/comedy"},{text:"Vanitha",link:"https://www.teluguone.com/vanitha"}]



export default function Header() {


        
                const {cats,setCats} = useContext(globalContext)
                const [loading,setLoading] = useState(true)

  useEffect(()  =>  {
  
       const loadData = async () => {
       
  
        try {
          const [allRes] = await Promise.all([
            fetch(
              `https://www.teluguone.com/news_api/newsAllCategoryiesWStoresJson`,
              {
                cache: "no-store",
              }
            ),
          ]);

          if (!allRes.ok) {
                throw new Error("all fetch failed");
              }
          const allJson = await allRes.json();
          const allData = Array.isArray(
            allJson?.home_category_web_stories
          )
            ? allJson.home_category_web_stories
            : [];
  
          const catResults = allData.map((item,index) => {

             return {label:item.category, id:item.feature_id, to:item.category?.toLowerCase(),end:false}
          }
        )
          setCats(catResults)
          // setError(null);
        } catch (err) {
          console.log(err.message);

        } finally {
          setLoading(false);
        }
      };
  
        //  setLoading(true);
         loadData();
  
     },[])




  return (
    <header className="site-header">
      <div className="top-bar webstories-header-main-links-container">
                        <nav>
                   {mainLinks.map((item,index) => <a key={index} href={item.link} target='_blank' rel='noreferrer' >{item.text}</a> )}
                   <div className="it-is-more">More▾<div className="more-list">
                             <a href="https://teluguone.com/vanitha/" target='_blank' rel='noreferrer' >Vanitha</a>
                             <a href="https://teluguone.com/toneastrology/" target='_blank' rel='noreferrer'>Astrology</a>
                             <a href="https://teluguone.com/comedy/"  target='_blank' rel='noreferrer' >Comedy</a>
                             <a href="https://www.teluguone.com/nri/index.html" target='_blank' rel='noreferrer' >Nri Corner</a>
                             <a href="https://www.teluguone.com/tonegreetings/index.html" target='_blank' rel='noreferrer' >Greetings</a>
                             <a href="https://teluguone.com/health/index.html" target='_blank' rel='noreferrer' >Health</a>
                             <a href="https://www.teluguone.com/sahityam/" target='_blank' rel='noreferrer' >Sahityam</a>
                             <a href="https://www.kidsone.in/" target='_blank' rel='noreferrer' >Kids</a>
                             <a href="https://www.teluguonefoundation.in/index.html" target='_blank' rel='noreferrer' >Charity</a>
                   </div></div>
              </nav>
      </div>
      <WebStoriesMobileHeader />
      <div className="brand-row">
        <Link to="/" className="logo">
           <img src="/webisodes/assets/images/webisodes_og2.jpg" alt="web-stories-logo" />
        </Link>
      </div>
      <nav className="page-links-container-nav">
        <div className="page-links-container">
          <ul>
             <NavLink
                  to={'/'}
                  end={true}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Home
                </NavLink>
              {loading ? Array(3).fill("0").map((i,index) =>  <li key={index}>
                <NavLink to=""  >..</NavLink> </li>)               
                 : cats.map((item) => (
                   <li key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.end}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </header>
  );
}


function  WebStoriesMobileHeader() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='webstories-mobile-header'>
      <Button  variant="primary" onClick={handleShow}>
      <svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true"><path stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" d="M4 7h22M4 15h22M4 23h22"></path></svg>
      </Button>

      <Offcanvas className="webstories-mobile-offcanvas" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
        <img  loading="lazy" src={`/webisodes/assets/images/tone_logo.webp`}
                        alt="tone-logo" className="header-logo"/>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <nav className="webstories-mobile-header-menu">
                {mobileMenuLinks.map((item,index) => <Link className='webstories-mobile-menu-link' rel="noopener noreferrer"  key={index} to={item.link}>{item.text}</Link>)}
             
            </nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}